import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDirectionLeft(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15.707 5.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 0 1.414l6 6a1 1 0 0 0 1.414-1.414L10.414 12l5.293-5.293a1 1 0 0 0 0-1.414Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
